"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var RefreshDataSpinner = /** @class */ (function (_super) {
    __extends(RefreshDataSpinner, _super);
    function RefreshDataSpinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RefreshDataSpinner.prototype.render = function () {
        {
            return this.props.loading ? (react_1.default.createElement("div", { className: "-loading -active" },
                react_1.default.createElement("div", { className: "-loading-inner" },
                    react_1.default.createElement("i", { className: "fa fa-spinner fa-spin fa-3x fa-fw" }),
                    react_1.default.createElement("span", { className: "sr-only" }, "Loading...")))) : null;
        }
    };
    return RefreshDataSpinner;
}(react_1.default.Component));
exports.default = RefreshDataSpinner;
